<app-data-table  tableId="process-table"
  #processTable
  [pageSizeOption]="[10, 50, 100, 200, 500, 1000, 5000]"
  [params]="params"
  [topOptions]="topOption"
  [tableConfig]="tableConfig"
  [selectionOptions]="selectionOptions"
  [fetchTableData]="fetchProcesses"
  [onClickRow]="onClickRow"
  [keepAppliedSearch]="true"/>

@if (importErrors.length) { 
  <div #importErrorsSection class="mt-4">
    <app-import-process-errors
      title="import process errors"
      [errors]="importErrors"
      (closed)="clearImportErrors()"
    />
  </div>
}